export default process?.env?.VUE_APP_API_URL || ''

// export default 'http://sosplantaoback.test/api'
